import { render, staticRenderFns } from "./TypeImage.vue?vue&type=template&id=e4c51372&scoped=true"
import script from "./TypeImage.vue?vue&type=script&lang=js"
export * from "./TypeImage.vue?vue&type=script&lang=js"
import style0 from "./TypeImage.vue?vue&type=style&index=0&id=e4c51372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c51372",
  null
  
)

export default component.exports